import { isEmptyObject } from '@/module/util'

export default {
    methods: {
        isEmptyObject
    }
}